import { branding } from "./branding.constants";

import appIconActguide from "../assets/images/app-icon-actguide.png";
import appIconPsychflex from "../assets/images/app-icon-psychflex.png";

type AppStoreListing = {
  name: string;
  url: string;
  icon: string;
};

const appStoreListings: { [name: string]: AppStoreListing } = {
  actguide: {
    name: "ACT Guide",
    url: "https://apps.apple.com/nl/app/act-guide-kennisplatform/id6764606820",
    icon: appIconActguide,
  },
  psychflex: {
    name: "Psychflex",
    url: "https://apps.apple.com/nl/app/psychflex-everyday-therapy/id6752890472",
    icon: appIconPsychflex,
  },
};

/**
 * The App Store listing of the new app for the current flavour, if any.
 */
const appStoreListing: AppStoreListing | null =
  appStoreListings[branding.imageSet ?? branding.graphicSet ?? ""] ?? null;

export { appStoreListing };
